import { API } from "@/lib/api";
import { ReadProjectLimit, WriteProjectLimit } from "@/types/projectLimit";
import { APIService, FetchListRequest } from "@/services/api";

const ProjectService = new APIService<ReadProjectLimit, WriteProjectLimit>(
  API.Projects,
);

export const ProjectLimitService = {
  getList: (
    projectId: string,
    date: string,
    fetchParams?: FetchListRequest<ReadProjectLimit>,
  ) => ProjectService.getList(fetchParams, `/${projectId}/limits/${date}`),
  patch: (projectId: string, values: WriteProjectLimit) =>
    ProjectService.patch(projectId, values, `limits`),
};
